/* @flow */
/*  global location */

/*************************************************************************
* ADOBE CONFIDENTIAL
* ___________________
*
*  Copyright 2018 Adobe
*  All Rights Reserved.
*
* NOTICE: All information contained herein is, and remains
* the property of Adobe and its suppliers, if any. The intellectual
* and technical concepts contained herein are proprietary to Adobe
* and its suppliers and are protected by all applicable intellectual
* property laws, including trade secret and copyright laws.
* Dissemination of this information or reproduction of this material
* is strictly forbidden unless prior written permission is obtained
* from Adobe.
**************************************************************************/

import React, { Component } from 'react';
import { Menu, MenuItem } from '@react/react-spectrum/Menu';
import Dropdown from '@react/react-spectrum/Dropdown';
import Checkmark from '@react/react-spectrum/Icon/Checkmark';
import ChevronDown from '@react/react-spectrum/Icon/ChevronDown'
import './LanguageSwitcher.scss';
import Button from '@react/react-spectrum/Button';
import * as url from 'url';

const languages = ['cs', 'da', 'de', 'en', 'es', 'fr', 'it', 'nl', 'nb', 'pl', 'pt', 'fi', 'sv', 'tr', 'ru', 'zh-Hans', 'zh-Hant', 'ja', 'ko'];

class LangugageSwitcher extends Component<Props> {
	handleLanguageSelect = (val: string) => {
		/* istanbul ignore else */
		if (val.match(/^[A-z0-9-]+$/)) {
			this.props.handleLanguageChange(val);
		}
	}

	handleDropdownOpen(event) {
		event.preventDefault();
		window.scrollTo(0, document.body.scrollHeight);
		const clientY = event.clientY;
		const clientX = event.clientX;
		setTimeout(() => {
			const wrongDirectionDropdown = document.querySelector('.language-picker .spectrum-Popover.react-spectrum-Popover.spectrum-Popover--bottom.is-open');
			if (wrongDirectionDropdown) {
				wrongDirectionDropdown.style.bottom = `${window.innerHeight - clientY + 10}px`;
				wrongDirectionDropdown.style.maxHeight = '50vh';
				wrongDirectionDropdown.style.top = 'auto';
				wrongDirectionDropdown.style.display = 'flex';
				if (Math.abs(clientX - window.innerWidth) < 100) {
					wrongDirectionDropdown.style.left = 'auto';
					wrongDirectionDropdown.style.right = '0px';
				}
				else if (clientX < 100) {
					wrongDirectionDropdown.style.left = '0px';
					wrongDirectionDropdown.style.right = 'auto';
				}
			}
		}, 200);

		window.addEventListener('resize', this.onResize);
		window.addEventListener('orientationchange', this.onOrientationChange);
	}

	handleDropdownClose() {
		window.removeEventListener('resize', this.onResize);
		window.removeEventListener('orientationchange', this.onOrientationChange);
	}

	onResize = () => {
		// Bug https://jira.corp.adobe.com/browse/CCH-3204
		// Fix by closing the popover when user resize the window
		/* istanbul ignore next */
		if ((typeof window.orientation === 'undefined') && (navigator.userAgent.indexOf('IEMobile') === -1) && document.querySelector('.language-list')) {
			const languageLinkRef = document.querySelectorAll('.language-picker-link');
			languageLinkRef[0].click();
		}
	};

	onOrientationChange = () => {
		// Bug https://jira.corp.adobe.com/browse/CCH-4791
		// Fix by closing the popover when user rotate the window
		/* istanbul ignore next */
		if (document.querySelector('.language-list')) {
			const languageLinkRef = document.querySelectorAll('.language-picker-link');
			languageLinkRef[0].click();
		}
	}

	renderLanguageList = (currentLocale) => {
		const supportedLangs = this.props.supportedLangs;
		const languageOptions = languages.map((langOption) => {
			/* istanbul ignore else */
			if (supportedLangs[langOption]) {
				if (currentLocale === langOption) {
					return <MenuItem
						value={langOption}
						key={langOption}
						className='selected lang-item'>
						{supportedLangs[langOption].displayName}
						<Checkmark size='S' />
					</MenuItem>;
				}
				return <MenuItem
					value={langOption}
					key={langOption}
					className='lang-item'>
					{supportedLangs[langOption].displayName}
				</MenuItem>;
			}

			return null;
		});

		return languageOptions;
	}

	/**
	 * Detect key press
	 * @param {any} event 
	 * @param {any} project 
	 */
	onKeyDown(event: any) {
		if (event.key === ' ' || event.key === 'Enter' || event.which === 13 || event.which === 32) {
			event.currentTarget.click();
			setTimeout(() => {
				/* istanbul ignore next */
				document.getElementsByClassName('selected lang-item')[0].focus();
			}, 300);
		}
	}

	render() {
		const supportedLangs = this.props.supportedLangs;

		return (
					<div className='language-container'>
						{/* <label htmlFor='pl-languageSelectEl--input' id='language-picker-title'>
							<FormattedMessage id='app.footer.language' />
						</label>&nbsp; */}
						{/* <div className='language-picker react-spectrum-provider spectrum spectrum--light spectrum--medium'> */}
							<Dropdown trigger='click' flip={true} crossOffset={70} className='dropdown' onOpen={event => this.handleDropdownOpen(event)} onSelect={event => this.handleLanguageSelect(event)} onClose={() => this.handlDropdownClose}>
								<Button className='language-picker-link' aria-labelledby='language-picker-title' tabIndex={0} onKeyDown={event => this.onKeyDown(event)} variant='primary' onClick={(e) => e.preventDefault()}>
									{supportedLangs[this.props.intl.locale].displayName}
									<ChevronDown size="S"/>
								</Button>
								<Menu role='menu' className='language-list'>
									{this.renderLanguageList(this.props.intl.locale)}
								</Menu>
							</Dropdown>
						{/* </div> */}
					</div>)
	}
}

export default LangugageSwitcher;
